export interface AuthSnapshot {
  readonly user: { readonly id: string } | null;
}

let snapshotProvider: (() => AuthSnapshot) | null = null;

export function setAuthSnapshotProvider(provider: () => AuthSnapshot): void {
  snapshotProvider = provider;
}

export function readAuthSnapshot(): AuthSnapshot {
  if (snapshotProvider === null) {
    return { user: null };
  }
  return snapshotProvider();
}
